// 專題 元件
import dayjs from 'dayjs';
import Link from 'next/link';
import Image from 'next/image';

const ProjectComponent = ({ project }) => {
    // 最近更新時間
    const modifiedTime = dayjs(project?.modifiedTime).format('YYYY.MM.DD');

    return (
        <div className="flex justify-start items-center gap-x-[50px] group blg:gap-x-[20px] umd:flex-col umd:gap-x-0 umd:gap-y-[6px] w-full">
            <Link
                href={`/project/${project?.slug}`}
                className="flex-shrink-0 img-box w-[294px] aspect-[294/221] rounded-[4px] overflow-hidden
        blg:w-[217px] blg:h-[163px] umd:w-full umd:h-[unset] umd:aspect-[345/232]"
            >
                {/* 專題圖片 */}
                <Image
                    className="hover-img"
                    width={294}
                    height={221}
                    src={project?.image || '/images/news/default_related.svg'}
                    alt={project?.title}
                    sizes="290px"
                />
            </Link>

            <Link href={`/project/${project?.slug}`}>
                {/* 標題 */}
                <h2
                    className="text-bd5b text-black line-clamp-1 mb-[22px] hover-text
        umd:line-clamp-[unset] ulg:mb-[7px] uxs:text-bd2b"
                >
                    {project?.title}
                </h2>

                {/* 副標 */}
                <h3 className="text-bd1b text-black9 line-clamp-1 ulg:line-clamp-[unset]">
                    {project?.subTitle}
                </h3>

                {/* 摘要 */}
                <h4 className="text-bd1m text-black9 line-clamp-2 mt-[12px] mb-[22px] umd:mb-[7px]">
                    {project?.brief}
                </h4>

                <p className="text-btn1 text-black5 5 relative no-select ulg:mt-[20px]">
                    <span className="trans group-hover:opacity-0">最近更新：{modifiedTime}</span>
                    <span
                        className="absolute opacity-0 left-0 top-[50%] translate-y-[-50%] inline-block px-[18px] py-[10px] text-white bg-black9 rounded-[2px]
          trans group-hover:opacity-[1]"
                    >
                        + Read more
                    </span>
                </p>
            </Link>
        </div>
    );
};

export default ProjectComponent;
